export default __webpack_public_path__ + "static/media/CMERevoked.cfb54fdc.svg";